
import { defineComponent } from '@vue/composition-api'
import { noop } from 'lodash'
export default defineComponent({
  name: 'TableRender',
  props: {
    renderfunc: {
      type: Function,
      default: () => noop
    },
    index: { type: [String, Number], default: '' },
    row: {
      type: Object,
      default: () => {}
    },
    col: {
      type: Object,
      default: () => {}
    }
  },
  render(h: Function) {
    // 自定义render
    // 只能返回一个Vnode节点
    // h:createElement
    // index:表格当前行下标
    // row: 表格当前行数据
    // 例如 customRender(h, {index, row}){}
    const render: any = this.renderfunc
    const component = render(h, {
      index: this.index,
      row: this.row,
      col: this.col
    })
    return component
  }
})
